import { create } from "../../../../../common/utils/zustand_state_manager";

/**
 * useCentroCustoListaFilters
 */

type State = {
    codigo: string;
    idsCentroCusto: number[];
    status: number;
};

type Action = {
    setCodigo: (codigo: string) => void,
    setIdsCentroCusto: (ids: number[]) => void,
    setStatus: (status: number) => void,
    clearFilters: () => void
};

export const useCentroCustoListaFilters = create<State & Action>((set) => ({
    codigo: "",
    idsCentroCusto: [],
    status: 3,
    setCodigo: (codigo) => set({ codigo }),
    setIdsCentroCusto: (idsCentroCusto) => set({ idsCentroCusto }),
    setStatus: (status) => set({ status }),
    clearFilters: () => set({
        codigo: "",
        idsCentroCusto: [],
        status: 3,
    }),
}));

export const initialFiltersValues: State = {
    codigo: "",
    idsCentroCusto: [],
    status: 3,

}